export default {
    state() {
        return {
            username: sessionStorage.getItem("username")||"",
            login: sessionStorage.getItem("login")||false,
        }
    },
    mutations:{
        setLogin: function(state, username) {
            if(username && username.trim()) {
                sessionStorage.setItem("username", username);
                sessionStorage.setItem("login", true);

                state.username = username;
                state.login = true;
            }else {
                sessionStorage.setItem("username", "");
                sessionStorage.setItem("login", false);
                
                state.login = false;
            }
        }
    },
    actions: {
        setLogin: function(context, username) {
            context.commit('setLogin',username);
        }
    },
    getters: {
        isLogin: function(state) {
            if(state.username != "" && state.login) {
                return true;
            }

            return false;
        }
    },
};